/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserRole } from '@app/settings/users/roles/user-role.model';
import { RolesFormComponent } from '@app/settings/users/roles/roles-form/roles-form.component';

@Injectable({
  providedIn: 'root',
})
export class RolesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open userRole form
   * @param userRole Dialog data
   */
  public open(userRole: null | UserRole = null) {
    const modal = this.modalService.open(RolesFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.role = userRole;
    return modal.result;
  }
}
